import React from "react"
import styled from "styled-components"
import Select from "react-select"

const StyledSelect = styled(Select)`
  .react-select__control {

    height: 50px;
    border-radius: 8px;
    border-color: ${({ theme }) => theme.colors.ui.inputBorder};

    &:hover {
      border-color: ${({ theme }) => theme.colors.ui.inputBorder};
    }

    transition: all 500ms ease;
  }

  .react-select__control--is-focused {
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: none;

    &:hover {
      border-color: ${({ theme }) => theme.colors.primary};
    }
  }

  .react-select__control, .react-select__option {
    font-family: ${({ theme }) => theme.fonts.avenirNextMedium};
  }

  .react-select__value-container {
    padding: 0;
    padding-left: 15px;
  }

  .react-select__single-value {
    color: ${({ theme }) => theme.colors.text.input};
    margin: 0;
    line-height: normal;
  }

  .react-select__indicator-separator {
    display: none;
  }
`

const SimpleDropdown = ({ onChange, name, ...props }) => {
  const handleChange = ({ value }) => {
    const customEvent = { target: { name, value } }
    
    onChange(customEvent)
  }

  return (
    <StyledSelect
      onChange={handleChange}
      {...props}
      classNamePrefix="react-select"
    />
  )
}

export default SimpleDropdown
